import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";

import "./assets/css/materialdesignicons.min.css";
import "./assets/scss/themes.scss";
import "@aws-amplify/ui-react/styles.css";

import reportWebVitals from "./reportWebVitals";

import "./index.css";
import App from "./App";
import awsExports from "./aws-exports";

// Configure Amplify
Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
